/**
 * Map filename to Monaco/syntax-highlighting language identifier.
 */
const LANG_MAP = {
  js: 'javascript', jsx: 'javascript', ts: 'typescript', tsx: 'typescript',
  py: 'python', java: 'java', c: 'c', cpp: 'cpp', h: 'c', cs: 'csharp',
  html: 'html', css: 'css', json: 'json', xml: 'xml',
  md: 'markdown', sh: 'bash', bash: 'bash', zsh: 'shell',
  sql: 'sql', yaml: 'yaml', yml: 'yaml',
  rb: 'ruby', go: 'go', rs: 'rust', php: 'php',
  txt: 'plaintext', log: 'plaintext', cfg: 'ini', ini: 'ini',
  dockerfile: 'dockerfile', makefile: 'makefile',
};

const SPECIAL_FILENAMES = {
  dockerfile: 'dockerfile',
  makefile: 'makefile',
  '.gitignore': 'plaintext',
  '.env': 'plaintext',
};

export function getLanguage(filename) {
  const lowerName = filename.toLowerCase();
  if (SPECIAL_FILENAMES[lowerName]) return SPECIAL_FILENAMES[lowerName];
  const ext = lowerName.split('.').pop();
  return LANG_MAP[ext] || 'plaintext';
}

/**
 * Build a hierarchical tree from a flat array of file objects.
 *
 * Each file must have a `path` property (e.g. "src/Main.java").
 * Returns an object where:
 *   - file nodes: { ...file, _isFile: true }
 *   - folder nodes: { _children: { ... } }
 */
export function buildFileTree(files) {
  const tree = {};
  for (const file of files) {
    const parts = file.path.split(/[/\\]/);
    let current = tree;
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      if (i === parts.length - 1) {
        // Don't overwrite an existing folder node with a file node
        if (!current[part] || !current[part]._children) {
          current[part] = { ...file, _isFile: true };
        }
      } else {
        if (!current[part] || !current[part]._children) {
          current[part] = { _children: {} };
        }
        current = current[part]._children;
      }
    }
  }
  return tree;
}

/**
 * The starter-code upload puts each Java file in the folder its package names (backend
 * utils/starterCodeLayout.js) and returns the moves; this is how staff are told.
 * Returns null when nothing moved.
 */
export function javaFileMovesNotice(moves) {
  if (!moves?.length) return null;
  const headline = moves.length === 1
    ? 'A Java file was moved to the folder its package line names, as Java requires.'
    : `${moves.length} Java files were moved to the folders their package lines name, as Java requires.`;
  return {
    headline: `${headline} Without that, students get no Run or Debug link and no errors across files.`,
    moves: moves.map(({ from, to }) => `${from} → ${to}`),
    note: 'Workspaces already created keep their files.',
  };
}
